import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../../../Services/Api/createApi";
// import { request } from "@/core/utils/axios"
import { store } from "../../../../features";
// @POST
const subscribeToSectionMutationFun = (payload) => {
  return api({
    url: "/subscribe_to_section",
    method: "POST",
    data: payload,
    headers: { "Authorization": `Bearer ${store.getState().Auth.userInfo.token}` },
  });
};

// ===================[Query & Mutation Hooks]===================

// @Mutation
export const useSubscribeToSectionMutation = () => {
  return useMutation({
    mutationFn: subscribeToSectionMutationFun,
  });
};
